/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Data_Load_Fail_DescriptionInputs */

const en_dialog_data_load_fail_description = /** @type {(inputs: Dialog_Data_Load_Fail_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please switch networks and try again. If the issue persists, contact support in the app.`)
};

const ar_dialog_data_load_fail_description = /** @type {(inputs: Dialog_Data_Load_Fail_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يرجى تبديل الشبكات والمحاولة مرة أخرى. إذا استمرت المشكلة، اتصل بالدعم في التطبيق.`)
};

const de_dialog_data_load_fail_description = /** @type {(inputs: Dialog_Data_Load_Fail_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte wechseln Sie das Netzwerk und versuchen Sie es erneut. Wenn das Problem weiterhin besteht, kontaktieren Sie den Support in der App.`)
};

const es_dialog_data_load_fail_description = /** @type {(inputs: Dialog_Data_Load_Fail_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambia de red e inténtalo de nuevo. Si el problema persiste, ponte en contacto con el servicio de asistencia de la app.`)
};

const fr_dialog_data_load_fail_description = /** @type {(inputs: Dialog_Data_Load_Fail_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez changer de réseau et réessayez. Si l'erreur persiste, contactez le support directement depuis l'application.`)
};

const it_dialog_data_load_fail_description = /** @type {(inputs: Dialog_Data_Load_Fail_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ti preghiamo di cambiare rete e di riprovare. Se il problema persiste, contatta il supporto nell'app.`)
};

const ja_dialog_data_load_fail_description = /** @type {(inputs: Dialog_Data_Load_Fail_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ネットワークを切り替えて再度お試しください。問題が解決しない場合は、アプリのサポートにお問い合わせください。`)
};

const ko_dialog_data_load_fail_description = /** @type {(inputs: Dialog_Data_Load_Fail_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`네트워크 전환 후 다시 시도하세요. 문제가 지속되면 앱에서 고객센터에 문의하세요.`)
};

const pt_br_dialog_data_load_fail_description = /** @type {(inputs: Dialog_Data_Load_Fail_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Troque de rede e tente novamente. Se o problema persistir, contate o suporte no aplicativo.`)
};

const ru_dialog_data_load_fail_description = /** @type {(inputs: Dialog_Data_Load_Fail_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переключите сети и повторите попытку. Если проблема не устранится, обратитесь в поддержку в приложении.`)
};

const th_dialog_data_load_fail_description = /** @type {(inputs: Dialog_Data_Load_Fail_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โปรดเปลี่ยนเครือข่ายแล้วลองอีกครั้ง หากปัญหายังคงอยู่ โปรดติดต่อฝ่ายสนับสนุนในแอป`)
};

const tr_dialog_data_load_fail_description = /** @type {(inputs: Dialog_Data_Load_Fail_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lütfen ağları değiştir ve tekrar dene. Sorun devam ederse, uygulamada destek hattıyla iletişime geç.`)
};

const zh_cn_dialog_data_load_fail_description = /** @type {(inputs: Dialog_Data_Load_Fail_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请切换网络后重试。如果问题仍未解决，请在 App 内联系客服。`)
};

const zh_tw_dialog_data_load_fail_description = /** @type {(inputs: Dialog_Data_Load_Fail_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`請先更換網路並嘗試再次開始，若無法順利解決，請回到 App 聯繫客服。`)
};

/**
* | output |
* | --- |
* | "Please switch networks and try again. If the issue persists, contact support in the app." |
*
* @param {Dialog_Data_Load_Fail_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_data_load_fail_description = /** @type {((inputs?: Dialog_Data_Load_Fail_DescriptionInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Data_Load_Fail_DescriptionInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_data_load_fail_description(inputs)
	if (locale === "ar") return ar_dialog_data_load_fail_description(inputs)
	if (locale === "de") return de_dialog_data_load_fail_description(inputs)
	if (locale === "es") return es_dialog_data_load_fail_description(inputs)
	if (locale === "fr") return fr_dialog_data_load_fail_description(inputs)
	if (locale === "it") return it_dialog_data_load_fail_description(inputs)
	if (locale === "ja") return ja_dialog_data_load_fail_description(inputs)
	if (locale === "ko") return ko_dialog_data_load_fail_description(inputs)
	if (locale === "pt_br") return pt_br_dialog_data_load_fail_description(inputs)
	if (locale === "ru") return ru_dialog_data_load_fail_description(inputs)
	if (locale === "th") return th_dialog_data_load_fail_description(inputs)
	if (locale === "tr") return tr_dialog_data_load_fail_description(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_data_load_fail_description(inputs)
	return zh_tw_dialog_data_load_fail_description(inputs)
});